import { createContext, ReactNode, useContext, useMemo, useState } from "react";

interface IResetPasswordContext {
    showResetPasswordDialog?: boolean;
    setShowResetPasswordDialog?: (show: boolean) => void;
    clientPublicId?: string;
    setClientPublicId?: (publicId: string) => void;
}

const ResetPasswordContext = createContext<IResetPasswordContext>({
    showResetPasswordDialog: false,
    setShowResetPasswordDialog: () => {},
    clientPublicId: "",
    setClientPublicId: () => {},
});
ResetPasswordContext.displayName = "ResetPasswordContext";

export function ResetPasswordContextProvider({ children }: { children: ReactNode }) {
    const [showResetPasswordDialog, setShowResetPasswordDialog] = useState(false);
    const [clientPublicId, setClientPublicId] = useState<string | undefined>(undefined);

    const contextValue: IResetPasswordContext = useMemo(() => {
        return { showResetPasswordDialog, setShowResetPasswordDialog, clientPublicId, setClientPublicId };
    }, [showResetPasswordDialog, setShowResetPasswordDialog, clientPublicId, setClientPublicId]);

    return <ResetPasswordContext.Provider value={contextValue}>{children}</ResetPasswordContext.Provider>;
}

export function useResetPasswordContext() {
    return useContext(ResetPasswordContext);
}
